import React from 'react';
import { StyleSheet, View, ActivityIndicator } from 'react-native';
import { appColors } from '../../assets/styles/global';
import { pixelDimensions } from '../../config/utils';
import { AppText } from '../form';

const Loader = ({ onTop }) => (
  <View style={[styles.loader, onTop && styles.overlay]}>
    <ActivityIndicator color={appColors.primary} size={60} />
    <AppText size="bold" style={styles.text}>Carregando</AppText>
    <AppText size="bold" style={styles.text}>Por favor, espere...</AppText>
  </View>
);

const styles = StyleSheet.create({
  loader: {
    height: 500,
    zIndex: 20,
    alignItems: 'center',
    justifyContent: 'center',
  },
  overlay: {
    position: 'absolute',
    height: '100%',
    width: '100%',
    backgroundColor: 'rgba(255,255,255,.7)',
  },
  text: {
    fontSize: pixelDimensions(5),
  },
});

export default Loader;
